module.exports = __webpack_public_path__ + "media/images/wallet/payment6-d28f56fd4700c327925dfe862dd33fa7.svg";